import React from 'react'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'


const ForgotForm = (
    {
        handleChange,
        handleSubmit,
        email,
        isDisable
    }) => {

    return (
        <>
            <Form onSubmit={handleSubmit} style={{display: "flex", flexDirection: "column", alignItems: "center"}} >
                <div className="row form__container form__reset-password">
                    <div className="col-12">
                        <Form.Group size="lg">
                            <Form.Label className="form__labels">Email <RequieredInputs/> </Form.Label>
                            <Form.Control
                                className="user-input login"
                                type="email"
                                value={email}
                                onChange={handleChange}
                                placeholder="Email"
                            />
                        </Form.Group>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                        <button
                            onClick={handleSubmit}
                            className="btn-landing" size="lg" type="submit"
                            disabled={isDisable}
                        >
                            GO
                        </button>
                    </div>
                </div>
            </Form>
        </>
    )
}

export default ForgotForm